/**
 * Build-time feature flags.
 *
 * Create React App inlines `REACT_APP_*` at build time, so each image
 * carries its own value: the staging image is built from
 * `.env.dist.stg` and the production image from `.env.dist.prod`.
 * A flag must therefore be read through these helpers rather than
 * checked ad hoc, so a missing or malformed value fails closed.
 */
const isFlagEnabled = (value: string | undefined): boolean => value === 'true';

/**
 * The DOD delivery monitor (queues, DLQ, metrics, history) is an
 * operator-facing diagnostic surface. It ships enabled on staging and
 * disabled on production, where the queue internals must stay hidden.
 */
export const isDodMonitorEnabled = (): boolean => isFlagEnabled(process.env.REACT_APP_DOD_MONITOR);
